<template>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'IUBHComplete',
  computed: {
    ...mapGetters([
      'appLoading',
      'locale',
    ]),
  },
  methods: {
    ...mapActions([
      'fetchTranslations',
    ]),
  },
  mounted() {
    let redirectLanguage = 'en';

    if (this.locale.language !== undefined && this.locale.language !== null) {
      redirectLanguage = this.locale.language.toLocaleLowerCase();
    }

    window.location.replace(`https://seemytype.com/${redirectLanguage}/thank-you/`);
  },
};
</script>
<style lang="scss">

</style>
